import { LoadingEnum } from "@perxis-auto/shared";
import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import "../forms/middleware.js";
import { formsActions } from "../forms/reducer.js";
import "../forms/selectors.js";
import * as internal_features_stages_actions from "./actions.js";
import { getStages } from "./actions.js";
const stagesAdapter = createEntityAdapter();
const initialState = {
  ...stagesAdapter.getInitialState(),
  current: null,
  service: null,
  loading: LoadingEnum.Idle
};
const stagesSlice = createSlice({
  name: "stages",
  initialState,
  reducers: {
    reset: () => initialState,
    setCurrent(state, action) {
      state.current = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setService(state, action) {
      state.service = action.payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(getStages.pending, (state) => {
      state.loading = LoadingEnum.Pending;
    });
    builder.addCase(getStages.fulfilled, (state, action) => {
      stagesAdapter.setAll(state, action.payload);
      state.loading = LoadingEnum.Succeeded;
    });
    builder.addCase(getStages.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = LoadingEnum.Failed;
    });
    builder.addCase(formsActions.getEstimate.rejected, (state, action) => {
      state.error = action.payload;
    });
  }
});
const stagesActions = {
  ...stagesSlice.actions,
  ...internal_features_stages_actions
};
export {
  stagesActions,
  stagesAdapter,
  stagesSlice
};
